import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import {MatListModule} from '@angular/material/list';
@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    MatBottomSheetModule,
    MatButtonModule,
    MatCardModule,
    MatDatepickerModule,
    MatIconModule,
    MatInputModule,
    MatNativeDateModule,
    MatMenuModule,
    MatRadioModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatStepperModule,
    MatTooltipModule,
    MatDialogModule,
    MatTabsModule,
    MatCheckboxModule,
    MatSlideToggleModule,
    MatSortModule,
    MatTableModule,
    MatFormFieldModule,
    MatListModule
  ],
  exports: [
    CommonModule,
    MatBottomSheetModule,
    MatButtonModule,
    MatCardModule,
    MatDatepickerModule,
    MatIconModule,
    MatInputModule,
    MatNativeDateModule,
    MatMenuModule,
    MatRadioModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatStepperModule,
    MatTooltipModule,
    MatDialogModule,
    MatTabsModule,
    MatCheckboxModule,
    MatSlideToggleModule,
    MatSortModule,
    MatTableModule,
    MatFormFieldModule,
    MatListModule
  ]
})
export class MaterialUIModule {}
